import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import './Quiz.css';

const data = {
  "questions": [
    {
      "questionNumber": 1,
      "question": "Can vaping help people quit smoking? Hmm...",
      "options": [
        {
          "text": "<span>No</span>",
          "response": "<p><strong>Not quite.</strong></p><strong>Vaping can help people quit smoking.</strong> When someone stops smoking, they crave nicotine. Vaping delivers nicotine in a less harmful way, by vaporising e-liquid instead of burning tobacco into smoke.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>Yes</span>",
          "response": "<p><strong>Nice one!</strong></p><strong>Vaping can help people quit smoking.</strong> When someone stops smoking, they crave nicotine. Vaping delivers nicotine in a less harmful way, by vaporising e-liquid instead of burning tobacco into smoke.Only people who smoke should vape.",
          "is_correct": true,
          "points": 1
        }
      ]
    },
    {
      "questionNumber": 2,
      "question": "Take a guess, how much nicotine is in vape liquid?",
      "options": [
        {
          "text": "<span>No</span> nicotine",
          "response": "<p><strong>Almost.</strong></p><strong>Vaping has variable nicotine.</strong> The e-liquid comes in different nicotine strengths. Heaps of people don't realise it, but nicotine isn't the cancer-causing chemical in cigarettes.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>Low</span> nicotine",
          "response": "<p><strong>Almost.</strong></p><strong>Vaping has variable nicotine.</strong> The e-liquid comes in different nicotine strengths. Heaps of people don't realise it, but nicotine isn't the cancer-causing chemical in cigarettes.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>High</span> nicotine",
          "response": "<p><strong>Almost.</strong></p><strong>Vaping has variable nicotine.</strong> The e-liquid comes in different nicotine strengths. Heaps of people don't realise it, but nicotine isn't the cancer-causing chemical in cigarettes.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>Variable</span> nicotine",
          "response": "<p><strong>You got it!</strong></p><strong>Vaping has variable nicotine.</strong> The e-liquid comes in different nicotine strengths. Heaps of people don't realise it, but nicotine isn't the cancer-causing chemical in cigarettes.",
          "is_correct": true,
          "points": 1
        }
      ]
    },
    {
      "questionNumber": 3,
      "question": "How harmful do you reckon vaping is, compared to smoking?",
      "options": [
        {
          "text": "<span>Less</span> harmful",
          "response": "<p><strong>That's right.</strong></p><strong>Vaping is less harmful than smoking.</strong> The vapour from heating an e-liquid is actually much less harmful than the smoke from burning tobacco. But vaping isn't harm free, so only do it if you're trying to quit smoking. Once you've quit smoking, you should quit vaping too, but only when you know you won't go back to smoking.",
          "is_correct": true,
          "points": 1
        },
        {
          "text": "<span>As</span> harmful",
          "response": "<p><strong>That's not quite right.</strong></p><strong>Vaping is less harmful than smoking.</strong> The vapour from heating an e-liquid is actually much less harmful than the smoke from burning tobacco. But vaping isn't harm free, so only do it if you're trying to quit smoking. Once you've quit smoking, you should quit vaping too, but only when you know you won't go back to smoking.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>Much more</span> harmful",
          "response": "<p><strong>That's not quite right.</strong></p><strong>Vaping is less harmful than smoking.</strong> The vapour from heating an e-liquid is actually much less harmful than the smoke from burning tobacco. But vaping isn't harm free, so only do it if you're trying to quit smoking. Once you've quit smoking, you should quit vaping too, but only when you know you won't go back to smoking.",
          "is_correct": false,
          "points": 0
        }
      ]
    },
    {
      "questionNumber": 4,
      "question": "Does vaping have side effects?",
      "options": [
        {
          "text": "<span>Yes</span>",
          "response": "<p><strong>Correct.</strong></p><strong>Vaping does have some side effects.</strong> It can make you cough, give you a dry and irritated mouth and throat.Vaping can make asthma symptoms worse and because most vapes include nicotine, regular vapers are dependant on nicotine.  Long-term risks of vaping are not known.",
          "is_correct": true,
          "points": 1
        },
        {
          "text": "<span>No</span>",
          "response": "<p><strong>That's incorrect.</strong></p><strong>Vaping does have some side effects.</strong> It can make you cough, give you a dry and irritated mouth and throat, and cause headaches. Long-term risks of vaping are not known.",
          "is_correct": false,
          "points": 0
        }
      ]
    },
    {
      "questionNumber": 5,
      "question": "How much does vaping cost compared to smoking?",
      "options": [
        {
          "text": "<span>Much</span> less",
          "response": "<p><strong>Yep.</strong></p><strong>Vaping costs much less than smoking.</strong> Apart from the first cost of the kit, someone who smokes 20 cigarettes a day can save $150 a week by switching to vaping.",
          "is_correct": true,
          "points": 1
        },
        {
          "text": "The <span>same</span>",
          "response": "<p><strong>Nope.</strong></p><strong>Vaping costs much less than smoking.</strong> Apart from the first cost of the kit, someone who smokes 20 cigarettes a day can save $150 a week by switching to vaping.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>Much</span> more",
          "response": "<p><strong>Nope.</strong></p><strong>Vaping costs much less than smoking.</strong> Apart from the first cost of the kit, someone who smokes 20 cigarettes a day can save $150 a week by switching to vaping.",
          "is_correct": false,
          "points": 0
        }
      ]
    },
    {
      "questionNumber": 6,
      "question": "What are the risks of long-term vaping?",
      "options": [
        {
          "text": "<span>No</span> Risks",
          "response": "<p><strong>That's not quite true.</strong></p><strong>There are unknown risks of long-term vaping.</strong> Basically vaping hasn't been around long enough to know the health effects of long-term use. But they're likely to be far less than smoking. Put simply, don't start if you don't smoke.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>Some</pan> risks",
          "response": "<p><strong>That's not quite true.</strong></p><strong>There are unknown risks of long-term vaping.</strong> Basically vaping hasn't been around long enough to know the health effects of long-term use. But they're likely to be far less than smoking. Put simply, don't start if you don't smoke.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>Unknown</span> risks",
          "response": "<p><strong>Totally.</strong></p><strong>Scientists are still learning about the long term health effects and risks of vaping</strong> as vaping hasn't been around for long enough yet. We know it isn't harmless, but it is less harmful than smoking. Once you've quit smoking you should aim to stop vaping too. Don't vape if you don't smoke.  ",
          "is_correct": true,
          "points": 1
        }
      ]
    },
    {
      "questionNumber": 7,
      "question": "Is second-hand vapour as harmful as second-hand smoke?",
      "options": [
        {
          "text": "<span>Yes</span>",
          "response": "<p><strong>Not true.</strong></p>Second-hand vapour is not as harmful as second-hand smoke. However, it's best not to vape around children and to be considerate of others.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "<span>No</span>",
          "response": "<p><strong>Good one.</strong></p>Second-hand vapour is not as harmful as second-hand smoke. However, it's best not to vape around children and to be considerate of others.",
          "is_correct": true,
          "points": 1
        }
      ]
    },
    {
      "questionNumber": 8,
      "question": "Are there currently laws around where you can vape?",
      "options": [
        {
          "text": "<span>Yes</span>",
          "response": "<strong>Spot on.</strong>\nPeople cannot vape in legislated smokefree areas. These areas have been Smokefree and Vapefree since 11 November 2020.",
          "is_correct": true,
          "points": 1
        },
        {
          "text": "<span>No</span>",
          "response": "<p><strong>That was tricky.</strong></p>People cannot vape in legislated smokefree areas. These areas have been Smokefree and Vapefree since 11 November 2020.",
          "is_correct": false,
          "points": 0
        }
      ]
    },
    {
      "questionNumber": 9,
      "question": "Who is nicotine not recommended for? Like who's it not great for?",
      "options": [
        {
          "text": "People who don't smoke",
          "response": "<p><strong>Not exactly.</strong></p>Nicotine is not recommended for people who don't smoke, children and pregnant women. That's because nicotine is harmful to children and unborn babies, and the unknown risks of long-term use mean people who don't smoke shouldn't start. Makes sense.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "Children and pregnant women",
          "response": "<p><strong>Not exactly.</strong></p>Nicotine is not recommended for people who don't smoke, children and pregnant women. That's because nicotine is harmful to children and unborn babies, and the unknown risks of long-term use mean people who don't smoke shouldn't start. Makes sense.",
          "is_correct": false,
          "points": 0
        },
        {
          "text": "All of the above",
          "response": "<p><strong>Bang on.</strong></p>Nicotine is not recommended for people who don't smoke, children and pregnant women. That's because nicotine is harmful to children and unborn babies, and the unknown risks of long-term use mean people who don't smoke shouldn't start. Makes sense.",
          "is_correct": true,
          "points": 1
        }
      ]
    },
    {
      "questionNumber": 10,
      "question": "Does the Ministry of Health back vaping to quit smoking? Almost there, last question.",
      "options": [
        {
          "text": "<span>Yes</span>",
          "response": "<p><strong>For sure.</strong></p>Vaping as a way to quit smoking is backed by the Ministry of Health. Why? Because vaping has the potential to help people quit smoking. It also contributes to New Zealand's Smokefree 2025 goal. But they only support it as a way to quit smoking. If you don't smoke, don't vape.",
          "is_correct": true,
          "points": 1
        },
        {
          "text": "<span>No</span>",
          "response": "<p><strong>Actually, they do.</strong></p>Vaping as a way to quit smoking is backed by the Ministry of Health. Why? Because vaping has the potential to help people quit smoking. It also contributes to New Zealand's Smokefree 2025 goal. But they only support it as a way to quit smoking. If you don't smoke, don't vape.",
          "is_correct": false,
          "points": 0
        }
      ]
    }
  ],
  "results": [
    {
      "text": "<span>Better luck next time!</span><br />You only scored",
      "cta": "There are plenty of myths out there about vaping. So what's true?",
      "ctaLinkFirst": "<a href='https://vapingfacts.health.nz/the-facts-of-vaping/'>Get the facts straight. Learn the truths about vaping<span>&#10230;</span></a>",
      "ctaLinkLast": "<a href='https://vapingfacts.health.nz/vaping-to-quit-smoking/helping-someone-quit-smoking.html'>Know someone who smokes? You can help them switch<span>&#10230;</span></a>"
    },
    {
      "text": "<span>Nice one!</span><br />You scored an awesome",
      "cta": "Seems you know a bit about vaping, but could know more.",
      "ctaLinkFirst": "<a href='https://vapingfacts.health.nz/the-facts-of-vaping/'>Get the facts straight. Learn the truths about vaping<span>&#10230;</span></a>",
      "ctaLinkLast": "<a href='https://vapingfacts.health.nz/vaping-to-quit-smoking/helping-someone-quit-smoking.html'> Know someone who smokes? You can help them switch<span>&#10230;</span></a>"
    },
    {
      "text": "<span>Nailed it!</span><br />You scored a perfect",
      "cta": "You clearly know your vape facts. So what can you do with them?",
      "ctaLinkFirst": "<a href='https://vapingfacts.health.nz/vaping-to-quit-smoking/'> If you smoke, here's how you can switch to vaping<span>&#10230;</span></a>",
      "ctaLinkLast": "<a href='https://vapingfacts.health.nz/vaping-to-quit-smoking/helping-someone-quit-smoking.html'>Know someone who smokes? You can help them switch<span>&#10230;</span></a>"
    }
  ]
};

const Quiz = () => {
  const quizData = data;
  // const [quizData, setQuizData] = useState(data);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showResponse, setShowResponse] = useState(false);
  const [score, setScore] = useState(0);
  const [quizComplete, setQuizComplete] = useState(false);

  const scrollWindowToTopOfApp = () => {
    // Smoothly scroll the browser window to the top of the quiz-root element
    const quizRoot = document.getElementById('quiz-root');

    if (quizRoot) {
      const rect = quizRoot.getBoundingClientRect();

      window.scrollTo({
        top: rect.top + window.pageYOffset - 60,
        behavior: 'smooth'
      });
    }
  }

  useEffect(() => {
    scrollWindowToTopOfApp();
  }, [])

  if (!quizData) {
    return <div className="quiz-container">Loading quiz...</div>;
  }

  const currentQuestion = quizData.questions[currentQuestionIndex];
  const isLastQuestion = currentQuestionIndex === quizData.questions.length - 1;

  const handleAnswerSelect = (optionIndex) => {
    if (showResponse) return; // Prevent changing answer after selection

    const option = currentQuestion.options[optionIndex];
    setSelectedAnswer(optionIndex);
    setShowResponse(true);

    if (option.is_correct) {
      setScore(prevScore => prevScore + option.points);
    }
  };



  const handleNext = () => {
    scrollWindowToTopOfApp();

    if (isLastQuestion) {
      setQuizComplete(true);
    } else {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setSelectedAnswer(null);
      setShowResponse(false);
    }
  };

  const getOptionLabel = (index) => {
    return String.fromCharCode(97 + index); // a, b, c, d, etc.
  };

  if (quizComplete) {
    // Determine which result to show based on score
    let resultIndex;
    if (score >= 0 && score <= 6) {
      resultIndex = 0;
    } else if (score >= 7 && score <= 9) {
      resultIndex = 1;
    } else if (score === 10) {
      resultIndex = 2;
    } else {
      resultIndex = 0; // fallback
    }

    const result = quizData.results[resultIndex];

    return (
      <div className="quiz-container">
        <div className="quiz-panels">
          {/* Left Panel - Result Text with Score */}
          <div className="panel left-panel">
            <div className="result-text">
              <div className="result-text-statement" dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(result.text)
              }} />
              <div className="result-text-large">
                <span className='text-white'>{score}</span> / 10
              </div>
            </div>
          </div>

          {/* Right Panel - CTA */}
          <div className="panel right-panel">
            <div className="result-cta">

                  <div className="result-text-statement" dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(result.cta)
                  }} />

                  <div className="result-text-statement-links" dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(result.ctaLinkFirst)
              }} />

                  <div className="result-text-statement-links" dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(result.ctaLinkLast)
                  }} />

            </div>
          </div>
        </div>
      </div>
    );
  }

  const selectedOption = selectedAnswer !== null ? currentQuestion.options[selectedAnswer] : null;

  return (
    <div className="quiz-container">
      <div className="quiz-panels">
        {/* Left Panel - Question */}
        <div className="panel left-panel">
          <div className="question-number">Question {currentQuestion.questionNumber} of 10</div>
          <div className="question-text">{currentQuestion.question}</div>
        </div>

        {/* Right Panel - Options or Response */}
        <div className="panel right-panel">
          {!showResponse ? (
            <div className="options-container">
              {currentQuestion.options.map((option, index) => (
                <label key={index} className="option-label">
                  <input
                    type="radio"
                    name={`question-${currentQuestion.questionNumber}`}
                    value={index}
                    checked={selectedAnswer === index}
                    onChange={() => handleAnswerSelect(index)}
                    className="option-radio"
                  />
                  <span className="option-letter">{getOptionLabel(index)}</span>
                  <span className="option-text" dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(option.text)
                  }} />
                </label>
              ))}
            </div>
          ) : (
            <div className="response-container">
              <div className={`response ${selectedOption.is_correct ? 'correct' : 'incorrect'}`}>
                  <div className="response-status">
                    <span className="response-status-text-icon">{selectedOption.is_correct ? '✓ ' : '✗ '}</span>
                  <div className="response-status-text"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(selectedOption.text)
                    }}
                  />
                </div>
                <div
                  className="response-text"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      selectedOption.response
                        .replace(/\n/g, '<br />')     // Single newlines = line breaks
                    )
                  }}
                />
              </div>
              <button onClick={handleNext} className="next-button">
                  {isLastQuestion ? 'View Results' : 'Next Question'}
                  <span>&#10230;</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Quiz;
